// Pessoas: foto de perfil (ou a inicial, para quem não tem foto) e busca por id.

import * as store from "./store.js";
import { el } from "./dom.js";

export function userById(id) {
  if (!id) return null;
  if (store.state.me?.id === id) return store.state.me;
  return (store.state.users || []).find((u) => u.id === id) || null;
}

const initial = (name) => [...String(name || "").trim()][0]?.toUpperCase() || "?";

// user: {id?, name?, avatar?}. Sem foto no objeto, procura a da pessoa pelo id.
export function avatar(user, cls = "") {
  const known = user?.id ? userById(user.id) : null;
  const name = user?.name || known?.name || "?";
  const src = user?.avatar || known?.avatar;
  const node = el("span", { class: "avatar" + (cls ? " " + cls : ""), title: name });
  if (!src) {
    node.textContent = initial(name);
    return node;
  }
  const img = el("img", { src, alt: "", draggable: "false" });
  img.addEventListener("error", () => { node.classList.remove("has-img"); node.replaceChildren(initial(name)); });
  node.classList.add("has-img");
  node.append(img);
  return node;
}
